import { createRequestTypes } from '../utils';

export const SUBSTANCE_FUNCTION_LIST = createRequestTypes('substanceFunction/SUBSTANCE_FUNCTION_LIST');
export const DELETE_SUBSTANCE_FUNCTION = createRequestTypes('substanceFunction/DELETE_SUBSTANCE_FUNCTION');
export const SAVE_SUBSTANCE_FUNCTION = createRequestTypes('substanceFunction/SAVE_SUBSTANCE_FUNCTION');
